import styled, { css } from "styled-components";

export const CarouselBannerWrap = styled.section`
	position: relative;
	width: 100%;
	/* height: 9.375rem; */
	overflow: hidden;
`;

export const DotsWrapper = styled.ul`
	width: 100%;
	position: absolute;
	bottom: 0.75rem;
	font-size: 0;
	pointer-events: none;
	display: flex;
	justify-content: center;
	grid-column-gap: 0.25rem;
`;
export const Dot = styled("li").withConfig({
	shouldForwardProp: (prop) => !["active"].includes(prop),
})<{ active?: boolean }>`
	width: 0.875rem;
	height: 0.125rem;
	background-color: rgba(255, 255, 255, 0.3);
	display: inline-block;

	${(props: { active?: boolean }) =>
		props.active &&
		css`
			background-color: #fff;
		`}
`;
